export type TutorialVideo = {
  id: string;
  title: string;
  description: string;
  filename: string;
  duration: number | null;
};

export const tutorialVideos: TutorialVideo[] = [
  {
    id: 'getting-started',
    title: 'Getting Started with Augmented Maps',
    description: 'Orient yourself with the interface - layout, mouse controls and buttons.',
    filename: 'GettingStarted.mp4',
    duration: null,
  },
  {
    id: 'site-selection',
    title: 'Site Selection',
    description: 'Find any site using search and filter options, then drill down using filtered lists and expanding hex maps.',
    filename: 'SiteSelection.mp4',
    duration: null,
  },
  {
    id: 'floor-mapping',
    title: 'Floor Plan Mapping',
    description: 'Align your floor plan to the building with precision three-point calibration for accurate spatial overlays.',
    filename: 'FloorMapping.mp4',
    duration: null,
  },
  {
    id: 'zone-overview',
    title: 'Zone Overview',
    description: 'Explore zone activity star ratings, drill into zone details, and pinpoint locations on the floor plan.',
    filename: 'ZoneOverview.mp4',
    duration: null,
  },
  {
    id: 'movement-visualisations',
    title: 'Movement Visualisations',
    description: 'Layer activity circles, movement heatmaps, and AI-powered pathway tracking onto your floor plan.',
    filename: 'MovementVisualisations.mp4',
    duration: null,
  },
  {
    id: 'visits-overview',
    title: 'Visits Overview',
    description: 'Drill into any technician visit from the timeline to review impacted zones, pest activity, and recommendations.',
    filename: 'VisitsOverview.mp4',
    duration: null,
  },
];

export const getVideoUrl = (filename: string): string => `/static/mp4files/${filename}`;
